var render = function render(){var _vm=this,_c=_vm._self._c;return _c('select',{staticClass:"form-control",staticStyle:{"width":"100%"},attrs:{"name":_vm.name}},_vm._l((_vm.data),function(item){return _c('option',{attrs:{"selected":"selected"},domProps:{"value":item.id}},[_vm._v(_vm._s(item.company_address.company))])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }